import { valueOf } from "@/types/common";

export const USER_TYPE = {
  ADMIN: "admin",
  ADMIN_MEMBER: "admin_member",
  RSO_USER: "rso_user",
  COMPANY_USER: "company_user",
  SUPPORT_USER: "support_user",
};

export type TUserType = valueOf<typeof USER_TYPE>;

export const ADMIN_ROLE = {
  MANAGER: "manager",
  SALE: "company_sale",
  CUSTOM_SERVICE: "custom_service",
  AUDITOR: "auditor",
};

export type TAdminRole = valueOf<typeof ADMIN_ROLE>;

export enum ERSOContractStatus {
  DURING_CONTRACT = "during_contract",
  CANCELED_CONTRACT = "canceled_contract",
  TRIAL = "trial",
  TRIAL_CANCELLED = "trial_cancelled",
}

export type TRSOContractStatus = valueOf<typeof ERSOContractStatus>;

export enum ECompanyContractStatus {
  DURING_CONTRACT = "during_contract",
  CANCELED_CONTRACT = "canceled_contract",
  TRIAL = "trial",
  TRIAL_CANCELLED = "trial_cancelled",
}

export type TCompanyContractStatus = valueOf<typeof ECompanyContractStatus>;

export const RESIDENCE_STATUS = {
  SPECIFIED_SKILL_NO1: 1,
  SPECIFIED_SKILL_NO2: 2,
  SPECIFIED_ACTIVITY: 3,
} as const;

export enum ESpecificSkillCertificateType {
  SPECIFIED_SKILL_NO1 = "1号",
  SPECIFIED_SKILL_NO2 = "2号",
}

export const SPECIFIC_SKILL_CERTIFICATE_TYPE = {
  [ESpecificSkillCertificateType.SPECIFIED_SKILL_NO1]: "1号",
  [ESpecificSkillCertificateType.SPECIFIED_SKILL_NO2]: "2号",
} as const;

export const LANGUAGE_CODE = {
  VI: "vi",
  MY: "my",
  ID: "id",
  EN: "en",
};

export type TLanguageCode = valueOf<typeof LANGUAGE_CODE>;

export enum EIndustryExamType {
  PAPER_TEST = "paper_test",
  CBT = "cbt",
}

export type TIndustryExamType = valueOf<typeof EIndustryExamType>;
